import { render, staticRenderFns } from "./AnchorTabItem.vue?vue&type=template&id=4f126a7c&scoped=true"
import script from "./AnchorTabItem.vue?vue&type=script&lang=js"
export * from "./AnchorTabItem.vue?vue&type=script&lang=js"
import style0 from "./AnchorTabItem.vue?vue&type=style&index=0&id=4f126a7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f126a7c",
  null
  
)

export default component.exports